import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  TextField,
  Box,
  Button,
  Tooltip,
  FormControl,
  CardMedia,
  Autocomplete,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { subYears, subDays } from 'date-fns';
import {
  addOrUpdateEmployeeOnboardingRequest,
  nextAvailableEmployeeCode,
} from '../../services/EmployeeService';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import './EmployeeOnboarding.css';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import KeycloakService from '../../services/KeycloakService';
import moment from 'moment';
import InputLabel from '@mui/material/InputLabel';
import {
  checkForJobType,
  checkForEmailId,
  getAllEmployees,
  updateEmployeeOnBoardingRequest,
  checkForEmployeeId,
} from '../../services/EmployeeService';

import { styled } from '@mui/material/styles';
import { CANCEL_BUTTON_TEXT, employeeCodeValidation } from '../../constants';
import { useDispatch } from 'react-redux';
import { SHOW_NOTIFICATION } from '../../constants';
import { getDesignations } from '../../admin/Services/MasterdataService';

import imageCompression from 'browser-image-compression';
import countryList from 'react-select-country-list';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { useTheme } from '@mui/material/styles';

const EditCard = (props) => {
  const theme = useTheme();
  const [phoneBorder, setPhoneBorder] = useState('1px');
  const {
    employee,
    isAddButton,
    handleClose,
    updatedUploadedPhoto,
    isHr,
    isAdmin,
    updatedEmployeeDetails,
    updatedFiles,
    updatedShowErrorMessageDob,
    updatedShowErrorMessageDoj,
    updatedShowErrorMessageDoi,
    updatedShowErrorMessageOEmail,
    updatedShowErrorMessagePEmail,
    updatedShowErrorMessagePhoneNo,
    updatedShowErrorMessageEmployeeCode,
    UpdatedEmployeePhoto,
    updatedShowErrorMessage,
    allEmployeesDetails,
    handleToggle,
    selectedStatus,
    designationNames,
    officeLocations, //props for the all location names
    leaveGroups,
    reportingManagers,
  } = props;

  const tenantId = process.env.REACT_APP_TENANT_ID;

  const [employeeDetails, setEmployeeDetails] = useState(
    employee ? employee : updatedEmployeeDetails,
  );
  const dispatch = useDispatch();
  const [uploadedPhoto, setUploadedPhoto] = useState(UpdatedEmployeePhoto);
  const [showErrorMessage, setShowErrorMessage] = useState(
    updatedShowErrorMessage,
  );
  const [showErrorMessageDob, setShowErrorMessageDob] = useState(
    updatedShowErrorMessageDob,
  );
  const [showErrorMessageDoj, setShowErrorMessageDoj] = useState(
    updatedShowErrorMessageDoj,
  );
  const [showErrorMessageDoi, setShowErrorMessageDoi] = useState(
    updatedShowErrorMessageDoi,
  );
  const [showErrorMessagePEmail, setShowErrorMessagePEmail] = useState(
    updatedShowErrorMessagePEmail,
  );

  const [showErrorMessagePEmail1, setShowErrorMessagePEmail1] = useState(
    updatedShowErrorMessagePEmail,
  );

  const [showErrorMessageOEmail, setShowErrorMessageOEmail] = useState(
    updatedShowErrorMessageOEmail,
  );
  const [showErrorMessageOEmail1, setShowErrorMessageOEmail1] = useState(
    updatedShowErrorMessageOEmail,
  );
  const [showErrorMessagePhoneNo, setShowErrorMessagePhoneNo] = useState(
    updatedShowErrorMessagePhoneNo,
  );

  const [showErrorMessageEmployeeCode, setShowErrorMessageEmployeeCode] =
    useState(updatedShowErrorMessageEmployeeCode);

  const phoneUtil = PhoneNumberUtil.getInstance();
  const [phonenumberToolTip, setPhonenumberToolTip] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = React.useState(updatedFiles);

  const [isValidPEmail, setIsValidPEmail] = useState(true);
  const [isValidOEmail, setIsValidOEmail] = useState(true);
  const [isDateValid, setIsDateValid] = useState(true);
  const [isDateValidDoj, setIsDateValidDoj] = useState(true);
  const [isDateValidDoi, setIsDateValidDoi] = useState(true);
  const [dobError, setDobError] = React.useState(null);
  const [dojError, setDojError] = React.useState(null);
  const [doiError, setDoiError] = React.useState(null);
  const [careerStartDateError, setCareerStartDateError] = React.useState(null);
  const [isValidEmployeeCode, setIsValidEmployeeCode] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [newJobType, setNewJobType] = useState('');
  //const [showInternshipDate, setShowInternshipDate] = useState(false);

  const maxDate = subYears(new Date(), 18);
  const minJoiningDate = subDays(new Date(), 30);

  const countryOptions = useMemo(() => countryList().getData(), []);

  const errorMessage = React.useMemo(() => {
    switch (dobError) {
      case 'invalidDate': {
        setIsDateValid(false);
        return 'Invalid date';
      }
      case 'ageLowerLimit': {
        setIsDateValid(false);
        return 'age must be greater than 18';
      }
      default: {
        if (
          employeeDetails.dateOfBirth > moment(maxDate).format('YYYY-MM-DD')
        ) {
          setIsDateValid(false);
          setDobError('ageLowerLimit');
          return;
        }
        setIsDateValid(true);
        return '';
      }
    }
  }, [dobError]);

  const errorMessage2 = React.useMemo(() => {
    switch (dojError) {
      case 'invalidDate': {
        setIsDateValidDoj(false);
        return 'Invalid date';
      }
      default: {
        if (!employeeDetails.dateOfJoining) {
          setIsDateValidDoj(false);
          return 'Date of joining is required'; // Set the error message for empty dateOfJoining
        } else {
          setIsDateValidDoj(true);
          return '';
        }
      }
    }
  }, [dojError, employeeDetails.dateOfJoining]);

  const errorMessage3 = React.useMemo(() => {
    switch (doiError) {
      case 'invalidDate': {
        setIsDateValidDoi(false);
        return 'Invalid date';
      }
      default: {
        if (!employeeDetails.dateOfInternship) {
          setIsDateValidDoi(false);
          return 'Date of internship is required';
        } else {
          setIsDateValidDoi(true);
          return '';
        }
      }
    }
  }, [doiError, employeeDetails.dateOfInternship]);

  const handleNameBlur = (event, value, id) => {
    if (id === 'firstName') {
      const { firstName, ...newemployeeDetails } = employeeDetails;
      setEmployeeDetails({
        ...newemployeeDetails,
        firstName: value.trim(),
      });
    } else if (id === 'lastName') {
      const { lastName, ...newemployeeDetails } = employeeDetails;
      setEmployeeDetails({
        ...newemployeeDetails,
        lastName: value.trim(),
      });
    }
  };

  // const [countryValue, setCountryValue] = useState('');

  const Approve = 'Approve';
  const Save = 'Save';
  useEffect(() => {
    if (isAddButton) {
      setUploadedPhoto(updatedUploadedPhoto);
      setEmployeeDetails(updatedEmployeeDetails);
      setFiles(updatedFiles);
    }
  }, []);

  const fetchEmployeeCode = async (jobType) => {
    const code = await nextAvailableEmployeeCode(jobType);

    setEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      employeeCode: code?.data?.data,
    }));
  };

  // useEffect to fetch the employee code when the component mounts
  useEffect(() => {
    if (employeeDetails.jobType) {
      fetchEmployeeCode(employeeDetails.jobType);
    }
  }, [newJobType]);

  const handleCountryChange = (value) => {
    setEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      usageLocation: value.target.value,
    }));
  };

  // Convenience default only: fills in "Country (for microsoft account)" from
  // the phone number's detected country, but only while it's still empty.
  // Never overrides an explicit choice or an already-saved value, so this
  // stays safe even if the phone library's detection effect fires more than
  // once (e.g. React StrictMode double-invoking effects in development).
  const handleCountrySelect = (country) => {
    if (country != null && countryList().getLabel(country)) {
      setEmployeeDetails((prevDetails) =>
        prevDetails?.usageLocation
          ? prevDetails
          : { ...prevDetails, usageLocation: country },
      );
    }
  };

  const handleEmployeeCodeChange = async (event) => {
    const value = event.target.value;
    const result = employeeCodeValidation(value);

    if (result == 0) return;

    if (result == 1) {
      setShowErrorMessageEmployeeCode(false);
      setIsValidEmployeeCode(false);
      setEmployeeDetails((prevDetails) => ({
        ...prevDetails,
        employeeCode: value,
      }));
      return;
    } else setIsValidEmployeeCode(true);

    try {
      const checkingEmployeeCode = await checkForEmployeeId(value, tenantId);

      if (checkingEmployeeCode?.data?.data === true) {
        setShowErrorMessageEmployeeCode(true);
      } else {
        setShowErrorMessageEmployeeCode(false);
      }

      setEmployeeDetails((prevDetails) => ({
        ...prevDetails,
        employeeCode: value,
      }));
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {}, [employeeDetails]);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const validatePhoneNumber = (phoneNumberString) => {
    try {
      const phoneNumber = phoneUtil.parseAndKeepRawInput(
        phoneNumberString,
        'ZZ',
      ); // 'ZZ' is the default region (unknown region)

      if (phoneUtil.isValidNumber(phoneNumber)) {
        setShowErrorMessagePhoneNo(false);
      } else {
        setShowErrorMessagePhoneNo(true);
      }
    } catch (error) {
      console.error('Error parsing phone number:', error);
    }
  };

  const handlePhoneChange = (value) => {
    setEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      phoneNumber: value,
    }));
    validatePhoneNumber(value);
  };

  const NON_BLOCKING_PHONE_KEYS = [
    'Backspace',
    'Delete',
    'Tab',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
    'Escape',
    'Enter',
  ];

  const handleKeyDown = (e) => {
    if (NON_BLOCKING_PHONE_KEYS.includes(e.key) || e.ctrlKey || e.metaKey) {
      return; // Always allow editing/navigation keys and shortcuts (copy/paste/select-all)
    }
    if (e.target.value.length >= 17) {
      e.preventDefault(); // Prevent typing more characters
    }
  };

  const handlePhotoUpload = async (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    if (file && file.type === 'image/png' && file.size <= 1024 * 1024) {
      reader.onload = (e) => {
        setUploadedPhoto(e.target.result);
      };

      reader.readAsDataURL(file);
      const options = {
        quality: 0.8,
      };
      try {
        const compressedFile = await imageCompression(file, options);
        setFiles(compressedFile);
      } catch (error) {
        console.log(error);
      }

      setShowErrorMessage(false);
    } else {
      setShowErrorMessage(true);
      setFiles(null);
    }
  };

  const SquareAvatar = styled(Avatar)(({ theme }) => ({
    width: '12rem',
    height: '10.1rem',
    cursor: 'pointer',
    borderRadius: theme.shape.borderRadius,
  }));

  const saveData = async () => {
    setIsLoading(true);

    let employee = '';

    if (
      files != null &&
      employeeDetails?.dateOfBirth &&
      (employeeDetails?.dateOfJoining || employeeDetails?.dateOfInternship) &&
      !showErrorMessageOEmail &&
      !showErrorMessagePEmail
    ) {
      setShowErrorMessage(false);
      setShowErrorMessageDob(false);
      setShowErrorMessageDoj(false);
      setShowErrorMessageDoi(false);
      setShowErrorMessageOEmail(false);
      setShowErrorMessagePEmail(false);
      setShowErrorMessagePhoneNo(false);
      employee = await addOrUpdateEmployeeOnboardingRequest(
        //
        employeeDetails,
        files,
      );

      if (employee.message == 'Mobile number is not valid.') {
        setShowErrorMessagePhoneNo(true);
        setIsLoading(false);
        return;
      }

      if (employee.status !== 200) {
        dipatchNotification(employee.type, employee.message);
        setIsLoading(false);
        return;
      }

      setEmployeeDetails({
        applierId: KeycloakService.getUserDetail(),
        tenantId: process.env.REACT_APP_TENANT_ID,
        employeeCode: '',
        firstName: '',
        lastName: '',
        designation: '',
        dateOfBirth: '',
        status: 'PENDING',
        phoneNumber: '',
        personalEmailId: '',
        dateOfJoining: moment().format('YYYY-MM-DD'),
        dateOfInternship: moment().format('YYYY-MM-DD'),
        careerStartDate: moment().format('YYYY-MM-DD'),
        internshipEndDate: null,
        organizationEmailId: '',
        jobType: '',
        locationId: null,
        locationName: '', //added the location filed
        leaveGroupId: null,
        reportingManagerId: null,
        reportingManagerEmployeeCode: null,
        reportingManagerEmail: null,
        reportingManagerDisplayName: null,
      });
      setFiles(null);
      if (employee.isError == false) {
        setIsLoading(false);
        handleClose();
        handleToggle('PENDING');
        setShowErrorMessageDob(false);
        setShowErrorMessageDoj(false);
      }
    } else if (showErrorMessageOEmail) {
      setShowErrorMessageOEmail(true);
    } else if (showErrorMessagePEmail) {
      setShowErrorMessagePEmail(true);
    } else if (showErrorMessagePhoneNo) {
      setShowErrorMessagePhoneNo(true);
    } else if (!employeeDetails?.dateOfBirth) {
      setShowErrorMessageDob(true);
    } else if (!employeeDetails?.dateOfJoining) {
      setShowErrorMessageDoj(true);
    } else if (files == null) {
      setShowErrorMessage(true);
    }

    setIsLoading(false);
  };
  const handleGenderChange = (event) => {
    const gender = event.target.value;
    setEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      gender: gender,
    }));
  };

  const handleJobTypeChange = async (event) => {
    // const jobType = event.target.value;
    // setEmployeeDetails((prevDetails) => ({
    //   ...prevDetails,
    //   jobType: jobType,
    // }));
    // setNewJobType(jobType);

    // const handleJobTypeChange = (e) => {
    const jobType = event.target.value;

    setEmployeeDetails((prev) => ({
      ...prev,
      jobType,
      dateOfJoining:
        jobType === 'INTERNSHIP' ? null : moment().format('YYYY-MM-DD'),
      dateOfInternship:
        jobType === 'INTERNSHIP' ? moment().format('YYYY-MM-DD') : null,
      careerStartDate: prev.careerStartDate || moment().format('YYYY-MM-DD'),
      // Internship end date is managed on user profile, not onboarding
      internshipEndDate: null,
    }));
    setNewJobType(jobType);
  };
  // };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 600);
    };
  };

  const handleDesignationChange = async (event) => {
    const designation = event.target.value;
    setEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      designation: designation,
    }));
  };

  useEffect(() => {}, [employeeDetails]);

  const handleOfficeLocationChange = async (event) => {
    const locationId = event.target.value;
    const selectedLocation = officeLocations.find(
      (loc) => loc.id === locationId,
    );
    setEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      locationId: locationId,
      locationName: selectedLocation ? selectedLocation.locationName : '-',
    }));
  };

  const handleLeaveGroupChange = (event) => {
    const value = event.target.value === '' ? null : event.target.value;
    setEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      leaveGroupId: value,
    }));
  };

  const formatReportingManagerLabel = (manager) => {
    if (!manager) return '';
    return manager.displayName || '';
  };

  const handleReportingManagerChange = (_event, value) => {
    setEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      reportingManagerId: value?.id || null,
      reportingManagerEmployeeCode: value?.employeeCode || null,
      reportingManagerEmail: value?.emailId || null,
      reportingManagerDisplayName: value?.displayName || null,
    }));
  };

  const selectedReportingManager =
    reportingManagers?.find(
      (manager) => manager.id === employeeDetails?.reportingManagerId,
    ) ||
    (employeeDetails?.reportingManagerId
      ? {
          id: employeeDetails.reportingManagerId,
          displayName: employeeDetails.reportingManagerDisplayName,
          employeeCode: employeeDetails.reportingManagerEmployeeCode,
          emailId: employeeDetails.reportingManagerEmail,
        }
      : null);

  const onDatePickerInputChange = (e) => {
    const { dateOfBirth, ...newemployeeDetails } = employeeDetails;

    const newDateOfBirth = e ? moment(new Date(e)).format('YYYY-MM-DD') : '';

    setEmployeeDetails({
      ...newemployeeDetails,
      dateOfBirth: newDateOfBirth,
    });

    // Reset date validity whenever the date of birth changes
    setIsDateValid(true);
  };

  const onJoiningDatePicketInputChange = (e) => {
    const { dateOfJoining, ...newemployeeDetails } = employeeDetails;

    const newDateOfJoining = e ? moment(new Date(e)).format('YYYY-MM-DD') : '';

    // Check if the date of joining is at least 18 years after the date of birth
    if (
      employeeDetails.dateOfBirth &&
      moment(newDateOfJoining).isBefore(
        moment(employeeDetails.dateOfBirth).add(18, 'years'),
      )
    ) {
      setIsDateValid(false);
    } else {
      setIsDateValid(true);
    }

    setEmployeeDetails({
      ...newemployeeDetails,
      dateOfJoining: newDateOfJoining,
      // Default Career Start Date from DOJ when not yet set
      ...(!employeeDetails.careerStartDate
        ? { careerStartDate: newDateOfJoining }
        : {}),
      // Clamp Career Start Date so it never ends up after the new joining date
      ...(employeeDetails.careerStartDate &&
      newDateOfJoining &&
      moment(employeeDetails.careerStartDate).isAfter(moment(newDateOfJoining))
        ? { careerStartDate: newDateOfJoining }
        : {}),
    });
  };

  useEffect(() => {
    if (employeeDetails.dateOfBirth > moment(maxDate).format('YYYY-MM-DD')) {
      setIsDateValid(false);
    }
  }, [employeeDetails]);

  const onInternshipDatePicketInputChange = (e) => {
    const { dateOfInternship, ...newemployeeDetails } = employeeDetails;

    const newDateOfInternship = e
      ? moment(new Date(e)).format('YYYY-MM-DD')
      : '';

    // Check if the date of joining is at least 18 years after the date of birth
    if (
      employeeDetails.dateOfBirth &&
      moment(newDateOfInternship).isBefore(
        moment(employeeDetails.dateOfBirth).add(18, 'years'),
      )
    ) {
      setIsDateValid(false);
    } else {
      setIsDateValid(true);
    }

    setEmployeeDetails({
      ...newemployeeDetails,
      dateOfInternship: newDateOfInternship,
      // Default Career Start Date from DOI when not yet set
      ...(!employeeDetails.careerStartDate
        ? { careerStartDate: newDateOfInternship }
        : {}),
      // Clamp Career Start Date so it never ends up after the new internship date
      ...(employeeDetails.careerStartDate &&
      newDateOfInternship &&
      moment(employeeDetails.careerStartDate).isAfter(
        moment(newDateOfInternship),
      )
        ? { careerStartDate: newDateOfInternship }
        : {}),
    });
  };

  useEffect(() => {
    if (employeeDetails.dateOfBirth > moment(maxDate).format('YYYY-MM-DD')) {
      setIsDateValid(false);
    }
  }, [employeeDetails]);

  const onChange = async (event, value, id) => {
    const regex = /^(|^[A-Za-z\s]+)$/; // Regular expression to allow only alphabetic characters and spaces
    if (id === 'firstName') {
      if (!regex.test(value)) {
        // Value contains numbers, do not update state
        return;
      }
      const { firstName, ...newemployeeDetails } = employeeDetails;
      setEmployeeDetails({
        ...newemployeeDetails,
        firstName: value,
      });
    } else if (id === 'lastName') {
      if (!regex.test(value)) {
        // Value contains numbers, do not update state
        return;
      }
      const { lastName, ...newemployeeDetails } = employeeDetails;
      setEmployeeDetails({
        ...newemployeeDetails,
        lastName: value,
      });
    } else if (id === 'tenantId') {
      const { tenantId, ...newemployeeDetails } = employeeDetails;
      setEmployeeDetails({
        ...newemployeeDetails,
        tenantId: value,
      });
    } else if (id === 'organizationEmailId') {
      setIsValidOEmail(false);
      const { organizationEmailId, ...newemployeeDetails } = employeeDetails;
      setEmployeeDetails({
        ...newemployeeDetails,
        organizationEmailId: value,
      });
    } else if (id === 'personalEmailId') {
      setIsValidPEmail(false);
      const { personalEmailId, ...newemployeeDetails } = employeeDetails;
      setEmployeeDetails({
        ...newemployeeDetails,
        personalEmailId: value,
      });
    } else if (id === 'id') {
      const { id: employeeId, ...newemployeeDetails } = employeeDetails;
      setEmployeeDetails({
        ...newemployeeDetails,
        id: value,
      });
    }
  };
  // console.log(designationNames, 'home');
  const handleBlur = async (id, value) => {
    const regex = /^$|^[A-Za-z0-9._%+-]+@beehyv\.com$/i;

    const PEmailregex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    try {
      if (id === 'organizationEmailId') {
        if (!regex.test(value)) {
          setShowErrorMessageOEmail1(true);
          setShowErrorMessageOEmail(true);
          setIsValidOEmail(false);
          return;
        } else {
          setShowErrorMessageOEmail1(false);
          setShowErrorMessageOEmail(false);
        }
        if (employee && value === employee.organizationEmailId) {
          setShowErrorMessageOEmail(false);
          setIsValidOEmail(true);
          return;
        }
        const checkingEmailId = await checkForEmailId(value);
        if (checkingEmailId?.data?.data === true) {
          setShowErrorMessageOEmail(true);
          setIsValidOEmail(false);
        } else {
          setShowErrorMessageOEmail(false);
          setIsValidOEmail(true);
        }
      } else if (id === 'personalEmailId') {
        if (!PEmailregex.test(value)) {
          setShowErrorMessagePEmail(true);
          setShowErrorMessagePEmail1(true);
          setIsValidPEmail(false);
          return;
        } else {
          setShowErrorMessagePEmail(false);
          setShowErrorMessagePEmail1(false);
        }

        if (employee && value.toLowerCase == employee.personalEmailId) {
          setShowErrorMessagePEmail(false);
          setIsValidPEmail(true);
          return;
        } else if (
          employeeDetails.organizationEmailId.toLowerCase() != '' &&
          value.toLowerCase() ===
            employeeDetails.organizationEmailId.toLowerCase()
        ) {
          setShowErrorMessagePEmail(true);
          setIsValidPEmail(false);
          return;
        } else {
          setShowErrorMessagePEmail(false);
          setIsValidPEmail(true);
        }
        // }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const validationFn = useCallback(debounce(handleBlur), []);

  const editData = async () => {
    try {
      if (isAdmin) {
        employeeDetails.status = 'APPROVED';
      }
      if (isHr && employeeDetails.status == 'REJECTED') {
        employeeDetails.status = 'PENDING';
      }
      let file1 = files;
      if (file1 == 1) {
        file1 = null;
      }
      let editEmployeeList = null;
      isHr
        ? (editEmployeeList = await addOrUpdateEmployeeOnboardingRequest(
            employeeDetails,
            file1,
          ))
        : (editEmployeeList = await updateEmployeeOnBoardingRequest(
            {
              ...employeeDetails,
              approverId: KeycloakService.getUserDetail(),
            },
            file1,
          ));

      if (editEmployeeList.message == 'Mobile number is not valid.') {
        setShowErrorMessagePhoneNo(true);
        // setIsLoading(false);
        return;
      }
      if (editEmployeeList.status !== 200) {
        dipatchNotification(editEmployeeList.type, editEmployeeList.message);
        setIsLoading(false);
        handleToggle(selectedStatus.value);
        return;
      }

      handleToggle(selectedStatus.value);
      handleClose();
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const card = (
    <>
      <FormControl>
        <form
          sx={{ padding: '1rem' }}
          onSubmit={(event) => {
            event.preventDefault();
            isAddButton ? saveData() : editData();
          }}
        >
          <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    flexDirection: 'row',
                    margin: '1rem',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      width: '33%',
                      flexDirection: 'column',
                    }}
                  >
                    <div
                      style={{
                        width: '87%',
                        marginRight: '0.4%',
                        marginLeft: '0.4%',
                        marginTop: '0.5rem',
                        marginBottom: '1.5rem',
                        marginTop: '4rem',
                      }}
                    >
                      <FormControl sx={{ width: '100%' }}>
                        <TextField
                          required
                          id="firstName"
                          label="First Name"
                          inputProps={{ maxLength: 50 }}
                          value={employeeDetails?.firstName || ''}
                          onChange={(e) =>
                            onChange(e, e.target.value, e.target.id)
                          }
                          onBlur={(e) =>
                            handleNameBlur(e, e.target.value, e.target.id)
                          }
                          className="onFocusBorder"
                        />
                      </FormControl>
                    </div>

                    <div
                      style={{
                        width: '87%',
                        marginRight: '0.4%',
                        marginLeft: '0.4%',
                        marginTop: '0.5rem',
                        marginBottom: '1rem',
                      }}
                    >
                      <FormControl sx={{ width: '100%' }}>
                        <InputLabel
                          htmlFor="job-type-select"
                          style={{ background: '#fff' }}
                          required
                          shrink
                        >
                          Job Type
                        </InputLabel>
                        <Select
                          required
                          labelId="job-type-select"
                          id="job-type-select"
                          value={employeeDetails?.jobType}
                          onChange={handleJobTypeChange}
                          displayEmpty
                          label="Job Type"
                          notched
                        >
                          <MenuItem value="FULL_TIME">FULL_TIME</MenuItem>
                          <MenuItem value="PART_TIME">PART_TIME</MenuItem>
                          <MenuItem value="INTERNSHIP">INTERNSHIP</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      width: '33%',
                      flexDirection: 'column',
                    }}
                  >
                    <div
                      style={{
                        width: '87%',
                        marginRight: '0%',
                        marginLeft: '0.4%',
                        marginTop: '0.5rem',
                        marginBottom: '1.5rem',
                        marginTop: '4rem',
                      }}
                    >
                      <FormControl sx={{ width: '100%' }}>
                        <TextField
                          required
                          id="lastName"
                          label="Last Name"
                          inputProps={{ maxLength: 50 }}
                          value={employeeDetails?.lastName || ''}
                          onChange={(e) =>
                            onChange(e, e.target.value, e.target.id)
                          }
                          onBlur={(e) =>
                            handleNameBlur(e, e.target.value, e.target.id)
                          }
                          className="onFocusBorder"
                        />
                      </FormControl>
                    </div>

                    <div
                      style={{
                        width: '87%',
                        marginRight: '0%',
                        marginLeft: '0.4%',
                        marginTop: '0.5rem',
                        marginBottom: '1rem',
                      }}
                    >
                      <FormControl sx={{ width: '100%' }}>
                        <InputLabel
                          htmlFor="designation-select"
                          style={{ background: '#fff' }}
                          required
                          shrink
                        >
                          Designation
                        </InputLabel>
                        <Select
                          sx={{ width: '100%' }}
                          labelId="designation-select"
                          id="designation-select"
                          value={employeeDetails?.designation}
                          onChange={handleDesignationChange}
                          displayEmpty
                          required
                          label="Designation"
                          notched
                        >
                          {designationNames?.map((designationName, index) => (
                            <MenuItem key={index} value={designationName}>
                              {designationName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <CardContent
                    className="Employee-Onboarding-Card-Content"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginTop: '2%',
                      position: 'relative',
                    }}
                  >
                    <div
                      style={{ position: 'relative', display: 'inline-block' }}
                    >
                      {showErrorMessage && (
                        <Tooltip
                          open={true}
                          title="Please add a png image of size less than 1MB before submitting."
                          classes={{
                            tooltip: 'custom-tooltip1',
                            arrow: 'custom-tooltip-arrow1',
                          }}
                          placement="bottom"
                        >
                          <label htmlFor="photo-upload">
                            {uploadedPhoto ? (
                              <CardMedia
                                component="img"
                                image={uploadedPhoto}
                                alt="Uploaded Photo"
                                style={{
                                  width: '8rem',
                                  height: '8rem',
                                  cursor: 'pointer',
                                }}
                              />
                            ) : (
                              <Avatar
                                src="/assets/images/ProfilePicPlaceholder.png"
                                sx={{
                                  width: '11rem',
                                  height: '10rem',
                                  cursor: 'pointer',
                                }}
                              />
                            )}
                          </label>
                        </Tooltip>
                      )}
                      {!showErrorMessage && (
                        <label htmlFor="photo-upload">
                          {uploadedPhoto ? (
                            <CardMedia
                              component="img"
                              image={uploadedPhoto}
                              alt="Uploaded Photo"
                              style={{
                                width: '8rem',
                                height: '8rem',
                                cursor: 'pointer',
                              }}
                            />
                          ) : (
                            <Avatar
                              src="/assets/images/ProfilePicPlaceholder.png"
                              sx={{
                                width: '11rem',
                                height: '10rem',
                                cursor: 'pointer',
                              }}
                            />
                          )}
                        </label>
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        id="photo-upload"
                        style={{ display: 'none' }}
                        onChange={handlePhotoUpload}
                        disabled={isAdmin ? true : false}
                      />
                    </div>
                  </CardContent>
                </div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexWrap: 'wrap',
                    flexDirection: 'row',
                    margin: '1rem',
                  }}
                >
                  <div
                    style={{
                      width: '28.7%',
                      marginRight: '0.4%',
                      marginLeft: '0.4%',
                      marginTop: '0rem',
                      marginBottom: '1.5rem',
                    }}
                  >
                    <FormControl sx={{ width: '100%' }}>
                      <InputLabel
                        htmlFor="gender-select"
                        style={{ background: '#fff' }}
                        required
                        shrink
                      >
                        Gender
                      </InputLabel>
                      <Select
                        required
                        labelId="gender-select"
                        id="gender-select"
                        value={employeeDetails?.gender}
                        onChange={handleGenderChange}
                        displayEmpty
                        label="Gender"
                        notched
                      >
                        <MenuItem value="male">Male</MenuItem>
                        <MenuItem value="female">Female</MenuItem>
                        <MenuItem value="other">Other</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    style={{
                      width: '28.7%',
                      marginRight: '0.4%',
                      // marginLeft: '0.4%',
                      marginTop: '0rem',
                      marginBottom: '1.5rem',
                      marginLeft: '3.8%',
                    }}
                  >
                    <Tooltip
                      open={showErrorMessageOEmail}
                      title={
                        !showErrorMessageOEmail1
                          ? 'Email Already Exist.'
                          : 'Invalid Email'
                      }
                      classes={{
                        tooltip: 'custom-tooltip1',
                        arrow: 'custom-tooltip-arrow1',
                      }}
                      placement="bottom"
                    >
                      <FormControl sx={{ width: '100%' }}>
                        <TextField
                          required
                          id="organizationEmailId"
                          type={'email'}
                          label="Organization Email Id"
                          value={employeeDetails?.organizationEmailId || ''}
                          onChange={(e) => {
                            onChange(e, e.target.value, e.target.id);
                            validationFn(e.target.id, e.target.value);
                          }}
                          className="onFocusBorder"
                          error={showErrorMessageOEmail}
                        />
                      </FormControl>
                    </Tooltip>
                  </div>
                  <div
                    style={{
                      width: '28.7%',
                      marginRight: '0.4%',
                      // marginLeft: '0.4%',
                      marginTop: '0rem',
                      marginBottom: '1.5rem',
                      marginLeft: '3.8%',
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Tooltip
                        open={
                          showErrorMessageDob && !employeeDetails?.dateOfBirth
                        }
                        title="Please select a valid date of birth."
                        classes={{
                          tooltip: 'custom-tooltip1',
                          arrow: 'custom-tooltip-arrow1',
                        }}
                        placement="bottom"
                      >
                        <FormControl required>
                          <DatePicker
                            label="Date of Birth *"
                            id="dob"
                            value={employeeDetails?.dateOfBirth}
                            onError={(newError) => {
                              setDobError(newError);
                              // setIsDateValid(false)
                            }}
                            onChange={onDatePickerInputChange}
                            maxDate={maxDate}
                            className="onFocusBorder"
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={!isDateValid}
                                helperText={errorMessage}
                              />
                            )}
                          />
                        </FormControl>
                      </Tooltip>
                    </LocalizationProvider>
                  </div>

                  <div
                    style={{
                      width: '31.7%',

                      marginLeft: '0.4%',
                      marginTop: '0.5rem',
                      marginBottom: '1.5rem',
                    }}
                  >
                    {/* {showErrorMessagePhoneNo && ( */}
                    <Tooltip
                      open={showErrorMessagePhoneNo && phonenumberToolTip}
                      title="Mobile number is not valid"
                      classes={{
                        tooltip: 'custom-tooltip1',
                        arrow: 'custom-tooltip-arrow1',
                      }}
                      onMouseEnter={() => {
                        setPhonenumberToolTip(true);
                      }}
                      onMouseLeave={() => {
                        setPhonenumberToolTip(false);
                      }}
                      placement="bottom"
                    >
                      <FormControl sx={{ width: '100%' }}>
                        <PhoneInput
                          required
                          id="phoneNumber"
                          placeholder="Phone Number *"
                          value={employeeDetails?.phoneNumber}
                          onChange={handlePhoneChange}
                          onKeyDown={handleKeyDown}
                          country="US"
                          onCountryChange={handleCountrySelect}
                          international={true}
                          style={{
                            width: '90%',
                            padding: `${phoneBorder === '1px' ? '1px' : '0px'}`,
                            border: `${
                              isFocused
                                ? `2px solid ${
                                    showErrorMessagePhoneNo
                                      ? theme.palette.error.main
                                      : '#4d6cd9'
                                  }`
                                : `1px solid ${
                                    showErrorMessagePhoneNo
                                      ? theme.palette.error.main
                                      : isHovered
                                        ? 'black'
                                        : '#c3bebc'
                                  }`
                            }`,

                            borderRadius: theme.shape.borderRadius || '5px',
                          }}
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                          onFocus={() => {
                            setIsFocused(true);
                            setPhoneBorder('2px');
                          }}
                          onBlur={() => {
                            setIsFocused(false);
                            setPhoneBorder('1px');
                          }}
                          error={showErrorMessagePhoneNo}
                        />
                      </FormControl>
                    </Tooltip>
                    {/* )} */}
                    {/* {!showErrorMessagePhoneNo && (
                      <FormControl sx={{ width: '100%' }}>
                        <PhoneInput
                          required
                          id="phoneNumber"
                          placeholder="Phone Number *"
                          value={employeeDetails?.phoneNumber}
                          onChange={handlePhoneChange}
                          onCountryChange={handleCountrySelect}
                          onKeyDown={handleKeyDown}
                          country="US"
                          international={true}
                          style={{ width: '90%' }}
                        />
                      </FormControl>
                    )} */}
                  </div>
                  <div
                    style={{
                      width: '28.7%',
                      marginRight: '0.4%',
                      marginTop: '0.5rem',
                      marginBottom: '1.5rem',
                      marginLeft: '1.5%',
                    }}
                  >
                    <Tooltip
                      open={showErrorMessagePEmail}
                      title={
                        !showErrorMessagePEmail1
                          ? 'Email Already Exists.'
                          : 'Invalid Email'
                      }
                      classes={{
                        tooltip: 'custom-tooltip1',
                        arrow: 'custom-tooltip-arrow1',
                      }}
                      placement="bottom"
                    >
                      <FormControl sx={{ width: '100%' }}>
                        <TextField
                          required
                          id="personalEmailId"
                          label="Personal Email Id"
                          type={'email'}
                          inputProps={{ maxLength: 100 }}
                          value={employeeDetails?.personalEmailId || ''}
                          onChange={(e) => {
                            onChange(e, e.target.value, e.target.id);
                            validationFn(e.target.id, e.target.value);
                          }}
                          className="onFocusBorder"
                          error={showErrorMessagePEmail}
                        />
                      </FormControl>
                    </Tooltip>
                  </div>

                  <div
                    style={{
                      width: '28.7%',
                      marginRight: '0.4%',
                      // marginLeft: '0.4%',
                      marginTop: '0.5rem',
                      marginBottom: '1.5rem',
                      marginLeft: '3.8%',
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Tooltip
                        open={
                          // showErrorMessageDoj && !employeeDetails?.dateOfJoining
                          showErrorMessageDoj &&
                          !employeeDetails?.dateOfJoining &&
                          showErrorMessageDoi &&
                          !employeeDetails?.dateOfInternship
                        }
                        title="Please select a date of joining or internship"
                        classes={{
                          tooltip: 'custom-tooltip1',
                          arrow: 'custom-tooltip-arrow1',
                        }}
                        placement="bottom"
                      >
                        <FormControl required>
                          {employeeDetails.jobType === 'INTERNSHIP' ? (
                            <DatePicker
                              label="Date of Internship "
                              id="doi"
                              value={employeeDetails?.dateOfInternship}
                              onChange={onInternshipDatePicketInputChange}
                              onError={(newError) => {
                                setDojError(newError);
                                // setIsDateValid(false)
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  InputLabelProps={{
                                    ...params.InputLabelProps,
                                    shrink: true,
                                  }}
                                />
                              )}
                            />
                          ) : (
                            <DatePicker
                              label="Date of Joining "
                              id="doj"
                              value={employeeDetails?.dateOfJoining}
                              onChange={onJoiningDatePicketInputChange}
                              minDate={minJoiningDate}
                              onError={(newError) => {
                                setDojError(newError);
                                // setIsDateValid(false)
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  InputLabelProps={{
                                    ...params.InputLabelProps,
                                    shrink: true,
                                  }}
                                />
                              )}
                            />
                          )}
                        </FormControl>
                      </Tooltip>
                    </LocalizationProvider>
                  </div>
                  <div
                    style={{
                      width: '28.7%',
                      marginRight: '0.4%',
                      marginLeft: '0.4%',
                      marginTop: '0rem',
                      marginBottom: '1.5rem',
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Tooltip
                        open={!!careerStartDateError}
                        title="Career start date cannot be after the joining date"
                        classes={{
                          tooltip: 'custom-tooltip1',
                          arrow: 'custom-tooltip-arrow1',
                        }}
                        placement="bottom"
                      >
                        <FormControl sx={{ width: '100%' }}>
                          <DatePicker
                            label="Career Start Date"
                            id="careerStartDate"
                            value={employeeDetails?.careerStartDate || null}
                            maxDate={
                              (employeeDetails?.jobType === 'INTERNSHIP'
                                ? employeeDetails?.dateOfInternship
                                : employeeDetails?.dateOfJoining) || undefined
                            }
                            onError={(newError) => {
                              setCareerStartDateError(newError);
                            }}
                            onChange={(e) => {
                              const v = e
                                ? moment(new Date(e)).format('YYYY-MM-DD')
                                : '';
                              const joiningDate =
                                employeeDetails?.jobType === 'INTERNSHIP'
                                  ? employeeDetails?.dateOfInternship
                                  : employeeDetails?.dateOfJoining;
                              if (
                                v &&
                                joiningDate &&
                                moment(v).isAfter(moment(joiningDate))
                              ) {
                                return;
                              }
                              setEmployeeDetails((prev) => ({
                                ...prev,
                                careerStartDate: v,
                              }));
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={!!careerStartDateError}
                                InputLabelProps={{
                                  ...params.InputLabelProps,
                                  shrink: true,
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </Tooltip>
                    </LocalizationProvider>
                  </div>
                  <div
                    style={{
                      width: '28.7%',
                      marginRight: '0.4%',
                      marginLeft: '3.8%',
                      marginTop: '0rem',
                      marginBottom: '1.5rem',
                    }}
                  >
                    <FormControl required sx={{ width: '100%' }}>
                      <InputLabel
                        htmlFor="location-select"
                        style={{ background: '#fff' }}
                        shrink
                      >
                        Office Location
                      </InputLabel>
                      <Select
                        labelId="location-select"
                        id="location-select"
                        value={employeeDetails?.locationId ?? ''}
                        onChange={handleOfficeLocationChange}
                        displayEmpty
                        label="Office Location"
                        notched
                      >
                        <MenuItem value="">
                          <em>No location selected</em>
                        </MenuItem>
                        {officeLocations?.map((officeLocation, index) => (
                          <MenuItem key={index} value={officeLocation?.id}>
                            {officeLocation.locationName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    style={{
                      width: '28.7%',
                      marginRight: '0.4%',
                      marginTop: '0rem',
                      marginBottom: '1.5rem',
                      marginLeft: '3.8%',
                    }}
                  >
                    <FormControl sx={{ width: '100%' }}>
                      <InputLabel
                        id="leave-group-select-label"
                        htmlFor="leave-group-select"
                        style={{ background: '#fff' }}
                        shrink
                      >
                        Leave Group
                      </InputLabel>
                      <Select
                        labelId="leave-group-select-label"
                        id="leave-group-select"
                        value={employeeDetails?.leaveGroupId ?? ''}
                        onChange={handleLeaveGroupChange}
                        displayEmpty
                        label="Leave Group"
                        notched
                      >
                        <MenuItem value="">
                          <em>No group selected</em>
                        </MenuItem>
                        {leaveGroups
                          ?.filter(
                            (leaveGroup) =>
                              leaveGroup?.isActive ||
                              leaveGroup?.id === employeeDetails?.leaveGroupId,
                          )
                          .map((leaveGroup) => (
                          <MenuItem key={leaveGroup?.id} value={leaveGroup?.id}>
                            {leaveGroup.groupName}
                            {leaveGroup?.isActive === false ? ' (inactive)' : ''}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    style={{
                      width: '61.6%',
                      marginRight: '0.4%',
                      marginTop: '0rem',
                      marginBottom: '1.5rem',
                      marginLeft: '0.4%',
                    }}
                  >
                    <Autocomplete
                      options={reportingManagers || []}
                      value={selectedReportingManager}
                      onChange={handleReportingManagerChange}
                      getOptionLabel={(option) =>
                        formatReportingManagerLabel(option)
                      }
                      isOptionEqualToValue={(option, value) =>
                        option?.id === value?.id
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Reporting Manager"
                          placeholder="Search by name"
                        />
                      )}
                    />
                  </div>
                  <div
                    style={{
                      width: '28.7%',
                      marginRight: '0.4%',
                      // marginLeft: '0.4%',
                      marginTop: '0rem',
                      marginBottom: '1.5rem',
                      marginLeft: '3.8%',
                    }}
                  >
                    <FormControl sx={{ width: '100%' }}>
                      <InputLabel
                        htmlFor="country-select"
                        style={{ background: '#fff' }}
                        required
                        shrink
                      >
                        Country (for microsoft account)
                      </InputLabel>
                      <Select
                        labelId="country-select" //
                        id="country-select"
                        value={employeeDetails?.usageLocation}
                        onChange={handleCountryChange}
                        required
                        displayEmpty
                        label="Country (for microsoft account)"
                        notched
                      >
                        {countryOptions.map((countryName, index) => (
                          <MenuItem key={index} value={countryName.value}>
                            {countryName.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  {isAdmin && (
                    <div
                      style={{
                        width: '87%',
                        marginRight: '0%',
                        marginLeft: '0.4%',
                        marginTop: '0.5rem',
                        marginBottom: '1.5rem',
                        marginTop: '4rem',
                      }}
                    >
                      <Tooltip
                        open={
                          showErrorMessageEmployeeCode || !isValidEmployeeCode
                        }
                        title={
                          showErrorMessageEmployeeCode
                            ? 'This Employee Code is not available!'
                            : isValidEmployeeCode
                              ? 'Tjhis Employee Code is available'
                              : 'Invalid Employee Code!'
                        }
                        classes={{
                          tooltip: 'custom-tooltip1',
                          arrow: 'custom-tooltip-arrow1',
                        }}
                        placement="bottom"
                      >
                        <FormControl sx={{ width: '100%' }} required>
                          <TextField
                            required
                            id="id"
                            label="Employee Code"
                            value={employeeDetails?.employeeCode || ''}
                            onChange={(e) => handleEmployeeCodeChange(e)}
                            className="onFocusBorder"
                          />
                        </FormControl>
                      </Tooltip>
                    </div>
                  )}
                </div>
              </div>
              <div className="space-between-container">
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    marginRight: '12px',
                    marginLeft: '30px',
                    marginBottom: '20px',
                    paddingBottom: '20px',
                    justifyContent: 'space-between',
                  }}
                >
                  <LoadingButton
                    variant="contained"
                    type="submit"
                    disabled={
                      !isValidPEmail ||
                      !isValidOEmail ||
                      !isDateValid ||
                      (!isDateValidDoj && !isDateValidDoi) ||
                      showErrorMessagePhoneNo ||
                      showErrorMessageEmployeeCode ||
                      !isValidEmployeeCode
                    }
                    loading={isLoading}
                    style={{
                      marginRight: '27px',
                    }}
                  >
                    {isAdmin ? Approve : Save}
                  </LoadingButton>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClose}
                  >
                    {CANCEL_BUTTON_TEXT}
                  </Button>
                </div>
              </div>
            </div>
          </Box>
        </form>
      </FormControl>
    </>
  );
  return <div>{card}</div>;
};
export default EditCard;
